// @ts-strict-ignore
import React, { useEffect, useState, useRef } from 'react'
import useScrollbarSize from 'react-scrollbar-size'
import { IonContent } from '@ionic/react'

import './styles.less'

const Content = props => {
	const contentRef = useRef<HTMLIonContentElement>()
	const [scrollbarWidth, setScrollbarWidth] = useState<number>()
	const { width } = useScrollbarSize()

	const isScrollable = (element: HTMLIonContentElement): boolean => {
		const y1 = element.scrollTop
		element.scrollTop += 1
		const y2 = element.scrollTop
		element.scrollTop -= 1
		const y3 = element.scrollTop
		element.scrollTop = y1

		return y1 !== y2 || y2 !== y3
	}

	useEffect(() => {
		if (width && contentRef?.current && isScrollable(contentRef.current)) {
			setScrollbarWidth(width)
		} else {
			setScrollbarWidth(0)
		}
	}, [width, contentRef])

	useEffect(() => {
		if (scrollbarWidth || scrollbarWidth === 0) {
			document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)
		}
	}, [scrollbarWidth])

	return (
		<IonContent {...props}>
			<div className="container">{props.children}</div>
		</IonContent>
	)
}

export default Content
